<template>
  <VModal :showing="showing" container-classes="max-w-screen-md" @update:showing="$emit('update:showing', $event)">
    <h2 class="text-xl mb-8 mr-8 truncate">
      Warning! {{ pluralize(embedSlides.length, 'This slide is', 'These slides are') }} being used for a 3D Presentation embed.
    </h2>
    <p class="text-gray-800 font-light">Visitors on your website will see an error when viewing your 3D Presentation embed.</p>
    <p v-for="slide in embedSlides" :key="slide.id" class="text-gray-800 ml-4">{{ slide.title }}</p>
    <div class="flex flex-row gap-4 mt-8 w-full justify-end">
      <VButton class="w-42" data-testid="cancel-button" @click="$emit('update:showing', false)">Cancel</VButton>
      <VButton class="w-42" variant="danger" data-testid="delete-button" @click="$emit('delete-slides', slides)">Delete anyway</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { computed } from 'vue'

import { pluralize } from '@/lib/pluralize'
import type { Slide } from '@/entities/deck'
import type { DeckEmbed } from '@/entities/embed'

const props = defineProps({
  slides: {
    type: Array as PropType<Slide[]>,
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
  deckEmbeds: {
    type: Array as PropType<DeckEmbed[]>,
    default: () => [],
  },
})

defineEmits(['delete-slides', 'update:showing'])

const embedSlides = computed(() => {
  return props.slides.filter(s => props.deckEmbeds.some(de => de.start_slide_id === s.id || de.end_slide_id === s.id))
})
</script>
